// src/pages/product/ClientProfilesPage.js
import FeaturePageTemplate from './FeaturePageTemplate';

export default function ClientProfilesPage() {
  return <FeaturePageTemplate slug="clients" />;
}